import { CommunityFeed } from '@/types'

export const commentsDisabledItemMap: Partial<Record<CommunityFeed['type'], boolean>> = {
  hurdle: true,
  profile_prompt: true,
  prompt: true,
  game: true,
}

export const feedIconsMap = {
  image: 'image',
  video: 'video',
  lesson: 'pencil',
  text: 'text',
  prompt: 'prompt',
  game: 'game',
  hurdle: 'game',
  review: 'note',
  review_question: 'note',
  profile_prompt: 'note',
  text_answer: 'note',
  story: 'award',
  video_answer: 'clipboard-pen',
  image_answer: 'clipboard-pen',
}
